/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Subscriber_DescInputs */

const tr_iade_iptal_s2_subscriber_desc = /** @type {(inputs: Iade_Iptal_S2_Subscriber_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel platformuna kayıt olmuş ve aktif aboneliği bulunan gerçek veya tüzel kişi.`)
};

const en_iade_iptal_s2_subscriber_desc = /** @type {(inputs: Iade_Iptal_S2_Subscriber_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A natural or legal person registered on the ShopPanel platform and holding an active subscription.`)
};

const de_iade_iptal_s2_subscriber_desc = /** @type {(inputs: Iade_Iptal_S2_Subscriber_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natürliche oder juristische Person, die sich auf der ShopPanel Plattform registriert hat und über ein aktives Abonnement verfügt.`)
};

const ru_iade_iptal_s2_subscriber_desc = /** @type {(inputs: Iade_Iptal_S2_Subscriber_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Физическое или юридическое лицо, зарегистрированное на платформе ShopPanel и имеющее действующую подписку.`)
};

/**
* | output |
* | --- |
* | "A natural or legal person registered on the ShopPanel platform and holding an active subscription." |
*
* @param {Iade_Iptal_S2_Subscriber_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_subscriber_desc = /** @type {((inputs?: Iade_Iptal_S2_Subscriber_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Subscriber_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_subscriber_desc(inputs)
	if (locale === "de") return de_iade_iptal_s2_subscriber_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_subscriber_desc(inputs)
	return tr_iade_iptal_s2_subscriber_desc(inputs)
});